import React, { useEffect, useState } from "react";
import "../assets/css/main.css"; // Assure-toi que le CSS est bien chargé

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500); // Disparaît après 2 secondes
  }, []);

  return (
    isLoading && (
      <div id="preloader"></div>
    )
  );
};

export default Preloader;
